import Model from './Model'
import ExpenseItem from './ExpenseItem'
import Payment from './Payment'
export default class Expense extends Model {

    resource()
    {
        return 'expenses'
    }

    items() {
        return this.hasMany(ExpenseItem)
    }

    payments() {
        return this.hasMany(Payment)
    }
}
